import { produce } from 'immer'
import { message } from 'antd'
import * as services from '@/pages/person/user/service'

const UserModel = {
  namespace: 'userGroupList',

  state: {
    groupList: [],
    list: [],
    deportmentLoading: false,
    shortcutTableLoading: false,
    refresh: false,
    groupId: '',
    searchValue: {
      page: 1,
      size: 20,
    },
    totalNum: 0,
  },

  effects: {
    // 获取分组
    *fetchGroupList({ payload }, { call, put }) {
      payload.asc = true
      const res = yield call(services.fetchGroupList, payload)
      yield put({
        type: 'setState',
        payload: {
          groupList: res?.data?.user_groups || [],
        },
      })
      return res
    },

    *phraseList({ payload }, { put, call, select }) {
      const { role, user_id, group_id } = payload
      const list = yield select((state) => state.shortcutList.groupList)
      const defaultId = list?.filter((i) => i?.name === '未分组')?.[0]?.value || list?.[0]?.value

      yield put({
        type: 'setState',
        payload: { deportmentLoading: true },
      })
      const res = yield call(services.phraseList, { ...payload, group_id: group_id || defaultId })
      yield put({
        type: 'setState',
        payload: {
          list: res?.data?.data,
          deportmentLoading: false,
          refresh: false,
          totalNum: res?.data?.page?.total,
        },
      })
      return res
    },

    *shortListByPage({ payload }, { put, call }) {
      yield put({
        type: 'setState',
        payload: { shortcutTableLoading: true },
      })
      const res = yield call(services.shortListByPage, {
        ...payload,
      })

      yield put({
        type: 'setState',
        payload: {
          list: (res?.data?.users ?? []).map(item => {
            try {
              const extendedData = JSON.parse(item?.extended_data ?? '{}')
              delete item.extended_data
              return { ...item, ...extendedData }
            } catch {
              return item
            }
          }),
          shortcutTableLoading: false,
          refresh: false,
          totalNum: res?.data?.total,
        },
      })
      return res
    },

    *deletePhrase({ payload }, { put, call, select }) {
      const res = yield call(services.deletePhrase, payload)
      return res
    },

    *resetGroupSearch({ payload }, { put, call }) {
      yield put({
        type: 'fetchGroupList',
        payload: {
          role: payload.role,
        },
      })
      yield put({
        type: 'shortListByPage',
        payload: { role: payload.role, group_id: payload.group_id },
      })
    },

    *deleteGroup({ payload }, { put, call, select }) {
      const res = yield call(services.deleteGroup, payload)
      return res
    },

    *batchDeleteGroup({ payload }, { call }) {
      const res = yield call(services.batchDeleteGroup, payload)
      return res
    },

    *clearPhrase({ payload }, { put, call }) {
      const res = yield call(services.clearPhrase)
      yield put({
        type: 'setState',
        payload: {
          groupList: [],
          list: [],
          groupId: '未分组',
        },
      })
      return res
    },

    *getUserGroup({ payload }, { call, put }) {
      const result = yield call(services.getUserGroup, payload)
      return result
    },
  },
  reducers: {
    setState(state = {}, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
    cleared: produce((state) => {
      state.groupList = []
      state.searchValue = {
        page: 1,
        size: 20,
      }
      state.list = []
      state.loading = false
      state.refresh = false
      state.groupId = ''
    }),
    resetSearchVal: produce((state) => {
      state.searchValue = {
        page: 1,
        size: 20,
      }
    }),
  },
}

export default UserModel
